import React, { Component } from "react";
import { Layout, Menu } from "antd";
const { Sider, Content } = Layout;
import Toolbar from "./toolbar";
import AppliedFilters from "../common/applied-filters";
import { keepOnlyLitigationQueryStrings, mapLitigationQueryStringToName } from "../../helpers/url";

const styles = {
  body: {
    width: "100%",
    padding: 30
  }
};

class LitigationSearch extends Component {
  render() {
    return (
      <Layout style={styles.body}>
        <Sider width={250} breakpoint="lg" collapsedWidth="0" style={{ background: "transparent", marginRight: 16 }}>
          <Toolbar />
        </Sider>
        <Content>
          <AppliedFilters fieldSelector={keepOnlyLitigationQueryStrings} fieldMapper={mapLitigationQueryStringToName} />
          <Menu selectedKeys={[this.props.location.pathname]} onClick={this._onMenuClick} mode="horizontal">
            <Menu.Item key="/litigation/caselist">{"CASE LIST"}</Menu.Item>
            <Menu.Item key="/litigation/analytics">{"ANALYTICS"}</Menu.Item>
          </Menu>
          {React.cloneElement(this.props.children, {
            key: this.props.location.pathname + this.props.location.search
          })}
        </Content>
      </Layout>
    );
  }

  _onMenuClick = item => {
    this.props.router.push({
      pathname: item.key,
      query: keepOnlyLitigationQueryStrings(this.props.location.query)
    });
  };
}

export default LitigationSearch;
